import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 4a8 8 0 110 16 8 8 0 010-16zm0-2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm-1.567 6.615a.842.842 0 01.861.007l4.286 2.626c.26.157.42.443.42.752s-.16.595-.42.752l-4.286 2.626a.842.842 0 01-.861.007.878.878 0 01-.433-.76v-5.25c0-.315.165-.605.433-.76z",
      fill: "#2d6ded"
    }
  )
), a = t;
export {
  a as default
};
